import { appRoleSchema } from '../schemas/app';

export const appRoles = appRoleSchema.options;

export const neighbourhoodRoles: AppRole[] = [
  'Neighbourhood_Manager',
  'Neighbourhood',
] as const satisfies AppRole[];

export const pcfraRoles = ['PCFRA_Manager', 'PCFRA_Editor'] as const satisfies AppRole[];

export const homeVisitsNecUsername = 'HOME_VISITS_API';
export const bsmNecUsername = 'BSM_API';

export const maxUserPinFailureCount = 3;

export const maxUploadFileSize = 28 * 1024 * 1024;

/**
 * Workaround for the fact that other fields can't be unset via the API.
 * For dates we set to this instead and check against the value
 * */
export const otherFieldDateUnsetValue = '1900-01-01';

export const defaultFallbackValue = '-';

export const defaultPageSize = 10;
export const maxPageSize = 100;
